export default __webpack_public_path__ + "static/media/section1_title2.652e9af4.png";